import secureLocalStorage from "react-secure-storage";
import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";

export default class PriorityRank extends GridCell {
  constructor(props){
    super(props);
    this.state={
      dropdownListData:props.priorityRankingsList
    }
  }
  
  handleChange(e) {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.text,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit
    ) {
      let updateData = {
        ...this.props.dataItem,
        priorityRankingName: e.target.value.text,
        priorityRankingId: e.target.value.value,
      };
      this.props.updateDropdownValue(updateData);
    }
  }

  handleEditCell = () => {
    if(this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open"){

      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };

  handlefilter=(event)=>{
    const filteredData=filterBy(this.props.priorityRankingsList,event.filter);
    this.setState({
      dropdownListData:filteredData
    });
  }
  
  render() {
    const { dataItem } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.ownerId;
    const selectedValue = this.props.priorityRankingsList?.find(
      (item) => item.value === dataItem.priorityRankingId
    );
    const value = selectedValue?.text;
    if ((this.props.field && this.props.field === this.props.dataItem.inEdit) ||
    this.props.dataItem.inEdit === true) {
      return (
        <td>
          <DropDownList
            // style={{ width: "100px" }}
            onChange={this.handleChange.bind(this)}
            value={selectedValue ? selectedValue : value}
            data={this.props ? this.state.dropdownListData : []}
            valueField="value"
            textField="text"
            // filterable={false}
            // onFilterChange={(e)=>this.handlefilter(e)}
            opened={true}
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId ) {
        return (
          <td onClick={this.handleEditCell} title={value ? value : ""}>
            {value ? value : ""}
          </td>
        );
      } else {
        return this.props.dataItem.roleName == "Standard User" ||
          this.props.dataItem.roleName == "View Only" || this.props.dataItem.isClosed === true ? (
          <td title={value ? value : ""}>{value ? value : ""}</td>
        ) : (
          <td onClick={this.handleEditCell} title={value ? value : ""}>
            {value ? value : ""}
          </td>
        );
      }
    }
  }
}
